import { Component, Mixins } from 'vue-property-decorator'
import APP_UTILITIES from '@/utilities/commonFunctions'
import APP_CONST from '@/constants/AppConst'
import AccountSettings from '@/mixins/accountSettings.mixin'
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin'
import { ScreenText } from '@/lang/ScreenText'
@Component
export class SessionTimeout extends Mixins(AccountSettings, DeviceWidthCheckerMixin) {
  screenText = new ScreenText()

  get sessionTimeOutHeader(): string {
    return this.screenText.getScreenText('SESSION_TIMEOUT_HEADER')
  }

  get sessionTimeOutSubHeader(): string {
    return this.screenText.getScreenText('SESSION_TIMEOUT_SUBHEADER')
  }

  get loginButtonText(): string {
    return this.screenText.getScreenText('BTN_LOGIN_CAPS')
  }

  onClick() {
    this.$gtm &&
      this.$gtm.trackEvent({
        event: null,
        category: 'Application Confirmation',
        action: 'click',
        label: 'Application Save Click Event Activated',
        value: 5000,
        noninteraction: false
      })
  }

  navigateToLogin() {
    APP_UTILITIES.removeCookies()
    APP_UTILITIES.removeSpecificCookie('applicationData')
    this.$router && this.$router.push(APP_CONST.APP_ROUTES.LOGIN)
  }

  mounted() {
    if (this.$route !== undefined && this.$gtm !== undefined) {
      this.$gtm.trackView(this.$route.name, this.$route.path)
    }
  }
}
